import { createPremiumModule, ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
import React from 'react';
import { BmCarousel } from './bm/BmCarousel';
import { BmExpand } from './bm/BmExpand';
import { StorefrontCarousel } from './storefront/StorefrontCarousel';
import { StorefrontExpand } from './storefront/StorefrontExpand';
import { TldOfferWidgetLayout } from './tldOfferWidget.layout';
import { useTldStripEligibility } from './useTldStripEligibility';
export const TldOfferWidgetModule = createPremiumModule('tldOfferWidget', [ModuleExtensions.customComponentsExtension(TldOfferWidgetLayout, 'Layouts', {
  version: 2,
  uniqueGlobalKey: 'tldOfferWidgetLayout-v2'
})], () => ({
  SDK: {
    bm: {
      carousel: props => /*#__PURE__*/React.createElement(BmCarousel, props),
      expand: props => /*#__PURE__*/React.createElement(BmExpand, props)
    },
    storefront: {
      carousel: props => /*#__PURE__*/React.createElement(StorefrontCarousel, props),
      expand: props => /*#__PURE__*/React.createElement(StorefrontExpand, props)
    },
    useEligibilityReport: useTldStripEligibility
  }
}));
//# sourceMappingURL=tldOfferWidget.module.js.map